import script from "./SetSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./SetSelect.vue?vue&type=script&setup=true&lang=ts"

import "./SetSelect.vue?vue&type=style&index=0&id=774c9996&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-774c9996"]])

export default __exports__